/*    
<summary>
  This functional component "ChangePassword" defines the props like initial values and functions for the child form 
  component.
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import userTypeEnum from "../../../../constants/enums/user-type-enum";
import { useStore } from "../../../../contexts/store-provider";
import {
  initialStateUpdateEmail
} from "../../../../core/initialState/change-password-state";
import { getStoreIdFromLocalStorage, getUserTypeFromLocalStorage } from "../../../../helpers/localstorage-helper";
import {
  IUpdateCustomerEmail
} from "../../../../models/forms/IChangePassword";
import { formatMessage } from "../../../../translations/format-message";
import ChangeCustomerEmailForm from "../forms/change-customer-email-form";

interface IProps {
  id: number;
  modalClosed: () => void;
}

let ChangeEmail: React.FC<IProps> = (props) => {
  const { customerManagementStore } = useStore();
  const {
    UpdateCustomerEmailService,
    changeCustomerEmailState,
    resetChangeEmail,
    GetCustomerByIdService,
    customerDetail
  } = customerManagementStore;

  // useEffect(() => {
  //   if (props.id) {
  //     let userTypeFromLocalStorage = getUserTypeFromLocalStorage();
  //     GetCustomerByIdService(props.id,
  //       (userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.SuperAdmin] && userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.HeadQuarter])
  //         ? getStoreIdFromLocalStorage()
  //         : null);
  //   }
  // }, []);
  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "changePasswordSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (changeCustomerEmailState.success) {
      toast.success(formatMessage("updated_success"));
      onModalClosed();
    }
  }, [changeCustomerEmailState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "changePasswordError" of the useEffect changed.
   */
  useEffect(() => {
    if (changeCustomerEmailState.error) {
      toast.error(formatMessage(changeCustomerEmailState.error));
      resetChangeEmail();
    }
  }, [changeCustomerEmailState.error]);

  /**
   * This function changes the user password by provides new password and user Id  to "chagePassword" store funtion that
   * send the request to Api.
   */
  const onSubmitForm = (values: IUpdateCustomerEmail) => {
    let submitData: IUpdateCustomerEmail;
    submitData = {
      CustomerId: props.id,
      Email: values.Email?.toLowerCase(),
    };
    if(customerDetail.Email !== submitData.Email)
      UpdateCustomerEmailService(submitData);
    else{
      toast.success(formatMessage("updated_success"));
      onModalClosed();
    }
  };

  /**
   * This function closes the pop up modal and reset ChangePassword observables (success, inprogress and error).
   */
  const onModalClosed = () => {
    resetChangeEmail();
    props.modalClosed();
  };

  return (
    <ChangeCustomerEmailForm
      id={props.id}
      initialValues={initialStateUpdateEmail}
      submitHandler={onSubmitForm}
      onModalClosed={onModalClosed}
      loading={changeCustomerEmailState.inProgress}
    />
  );
};

export default observer(ChangeEmail);
